// extracted by mini-css-extract-plugin
export default {"post-entry":"MainBlogPost_post-entry__Q0Gj7","thumbnail":"MainBlogPost_thumbnail__8oEMZ"};